module.exports = __webpack_public_path__ + "img/office_default.25d3d13b.png";